import { gql } from '@apollo/client';

export const GET_LM_LOCAL_HUB_SORTING_CODES = gql`
    query GetLmLocalHubSortingCodes($warehouseId: Long!) {
        getLmLocalHubSortingCodes(warehouseId: $warehouseId)
    }
`;

export interface GetLmLocalHubSortingCodesResponse {
    /** 当前仓的 LM 本地派送尾程 Hub sortingCode 候选（后端按 common_config 映射，未配置兜底 [LA, LAX]） */
    getLmLocalHubSortingCodes: string[];
}
